module.exports = __webpack_public_path__ + "static/media/img130.87cf165a.jpg";